import { render, staticRenderFns } from "./content-title.vue?vue&type=template&id=5f83b0c8&"
import script from "./content-title.vue?vue&type=script&lang=js&"
export * from "./content-title.vue?vue&type=script&lang=js&"
import style0 from "./content-title.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "content-title.vue"
export default component.exports